<template>
  <div id="modal-info-body">
    <h2 style="text-align: center;">Desempenho geral</h2>

    <p>
      Este relatório apresenta um <strong>ranking</strong> das equipes do
      município com relação aos indicadores da APS. Podem ser visualizados aqui
      os dados do quadrimestre definitivamente liberados no SISAB e importados
      em
      <strong>INÍCIO >> Administração >> Indicadores Previne Brasil</strong> e a
      previsão de resultado calculada com base no e-SUS PEC ou Centralizador.
    </p>
    <h3>Atenção!</h3>
    <P
      >A ordem de classificação das equipes é um indicativo de que as que estão
      nas últimas posições precisam de mais apoio em termos de qualificação ou
      disponibilidade de equipamentos para o registro adequado dos dados no
      prontuário eletrônico.</P
    >
    <h3>RECOMENDAÇÃO</h3>

    <p>
      O resultado dos indicadores por equipe liberado a cada quadrimestre fica
      com acesso restrito, ou seja, somente os profissionais que têm liberação
      do CPF ou o gestor municipal da APS pode ter acesso no
      <a href="https://acesso-egestoraps.saude.gov.br/login" target="_blank"
        >SISAB</a
      >.
    </p>
    <p>
      Para disponibilizar os
      <strong
        >resultados dos indicadores do último quadrimestre (DEFINITIVO)</strong
      >
      para os profissionais de saúde, o Administrador municipal do e-SUS pode
      baixar as planilhas e importar aqui no sistema. Essa ação pode ser feita
      em
      <strong>INÍCIO >> Administração >> Indicadores Previne Brasil</strong>. A
      importação desses dados pode acontecer sempre que o resultado do último
      quadrimestre for liberado no SISAB, na área de
      <a
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorPainel.xhtml"
        target="_blank"
        >indicadores de desempenho</a
      >
      .
    </p>

    <h3>FUNCIONALIDADES</h3>

    <p>
      As informações podem ser visualizadas considerando a
      <strong>PREVISÃO (e-SUS PEC)</strong>
      ou o resultado <strong>DEFINITIVO (SISAB)</strong>. Para isso basta
      alternar o filtro (DEFINITIVO ou PREVISÃO).
    </p>
    <p>
      Ao escolher um PERÍODO, sempre será mostrado os dados da previsão para o
      mês escolhido.
    </p>

    <p>
      O filtro <strong>CLASSIFICAR POR</strong> vai ordenar, ou classificar as
      equipes de acordo com o <strong>ISFE</strong> ou
      <strong>DESEMPENHO</strong>. Dependendo da escolha, a ordenação das
      equipes pode mudar, pois se:
    </p>

    <ul>
      <li>
        A <strong> equipe A </strong>tem resultado de 45% em consultas de
        pré-natal (I1), 60% em exames de HIV e Sífilis (I2), 60% em consultas
        odontológicas na gestante (i3), 40% em citopatológico (I4), 95% em
        imunização (I5), 50% em atendimento de hipertensão (I5) e 50% em
        atendimento de diabetes (I7), então o seu
        <strong>ISFE é 10 (dez)</strong>, mas seu
        <strong>DESEMPENHO é 605 (seiscentos e cinco)</strong>, uma vez que
        somente atingiu o mínimo da meta de cada indicador;
      </li>
      <li>
        Por outro lado, a <strong>equipe B</strong> tem resultado de 100% em
        cada um dos indicadores da APS, então seu
        <strong>ISFE é 10 (dez)</strong> e o
        <strong>DESEMPENHO é 1000 (MILL)</strong>.
      </li>
    </ul>
    <br />
    <h3>Atenção!</h3>
    <p>
      O <strong>ISFE</strong> identifica apenas se a equipe está batendo a meta
      mínima exigida em cada indicador. O <strong>DESEMPENHO</strong> mostra,
      realmente, qual é o desempenho da equipe em relação aos indicadores. >
      considerando os quatro meses que compõe o quadrimestre avaliado.
    </p>

    <p>A tabela apresentada com os resultados, mostra:</p>

    <ul>
      <li>
        <strong>ORDEM</strong> – indica a classificação da equipe e varia entre
        1º até o número máximo de equipes que tem o município;
      </li>
      <li>
        <strong>NOME DA EQUIPE</strong> – apresenta o nome da equipe de acordo
        com o registro no CNES e importação do XML do SISAB no e-SUS PEC ou
        Centralizador;
      </li>
      <li>
        <strong>INE</strong> – Identificador Nacional de Equipe, um número que
        identifica unicamente a equipe e está cadastrado no CNES;
      </li>
      <li>
        <strong>Ix</strong> – indicador (I), número (x) para identificar
        numericamente os indicadores. Ao final desse artigo tem explicação
        detalhada sobre cada indicador.
      </li>
      <li>
        <strong>ISFE</strong> – Indicador Sintético Final da Equipe, calculado
        usando a mesma fórmula do ISF municipal. Este resultado pode ser
        DEFINITIVO ou uma PREVISÃO;
      </li>
      <li>
        <strong>DESEMPENHO</strong> – é calculado pela média dos resultados
        individuais dos indicadores e ponderada pelos pesos de cada indicador
        multiplicado pelo ISF;
      </li>
      <li>
        <strong>PERIODO</strong> – mostra o período a que se refere os dados que
        estão em tela. O período pode ser quadrimestral (DEFINITIVO) ou mensal
        (PREVISÃO);
      </li>
      <li>
        <strong>FONTE</strong> – mostra a data em que os dados foram preparados
        para o Monitoramento e Avaliação. É importante que essa data esteja o
        mais perto de hoje possível.
      </li>
    </ul>
    <br />
    <h3>Atenção!</h3>
    <p>
      Se o resultado entre <strong>PREVISÃO</strong> e
      <strong>DEFINITIVO</strong> estiverem diferentes, analisando-se o mesmo
      quadrimestre (mês 4 = Q1, mês 8 = Q2 e mês 12 = Q3), então é importante
      verificar se ocorreu reprovação de dados no SISAB. Essa verificação pode
      ser feita com acesso restrito no
      <a
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/envio/RelValidacao.xhtml"
        target="_blank"
        >Relatório de Validação</a
      >
      considerando os quatro meses que compõe o quadrimestre avaliado.
    </p>
    <p>
      <strong
        >Pode existir diferença de dados entre o e-SUS PEC ou Centralizador e o
        SISAB, pois para chegar no SISAB os dados passam por uma validação. Para
        mais informações, recomenda-se a leitura da
        <a
          href="http://189.28.128.100/dab/docs/portaldab/documentos/esus/relatorio_validacao_2_2021_nota.pdf"
          target="_blank"
          >Nota Técnica</a
        >
        que explica em detalhes o processo de validação.</strong
      >
    </p>
    <p>
      Basicamente, a reprovação de dados no SISAB acontece por divergência entre
      as lotações dos profissionais de saúde no e-SUS PEC ou Centralizador e o
      cadastro no CNES. Para evitar essas reprovações, recomenda-se ao
      Administrador municipal do e-SUS, pelo menos uma vez por semana, aqui no
      sistema ir em <strong>INÍCIO  Profissionais PEC CNES</strong>, esperar os
      dados carregar e verificar se tem divergências, as quais podem ser
      comunicadas ao Administrador do CNES para fazer as devidas adequações.
    </p>
    <p>
      É sempre recomendado, pelo menos uma vez por mês, importar o XML gerado
      pelo SISAB no sistema e-SUS PEC ou Centralizador para manter as lotações
      dos profissionais de saúde sempre atualizadas.
    </p>
    <br />
    <h2 class="notas-tecnicas">NOTAS TÉCNICAS</h2>
    <p>
      <strong>Apresentação do Conjunto dos 7 Indicadores Previne Brasil</strong>
    </p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_12.pdf"
        target="_blank"
        >Nota Técnica 12/2022</a
      >
       - Indicadores de Pagamento por Desempenho do Programa Previne Brasil
      (2022) de que trata a <a
        href="https://www.in.gov.br/en/web/dou/-/portaria-gm/ms-n-102-de-20-de-janeiro-de-2022-375495336"
        target="_blank"
        >Portaria GM/MS nº 102, de 20 de janeiro de 2022</a
      >, que alterou a <a
        href="https://www.in.gov.br/en/web/dou/-/portaria-n-3.222-de-10-de-dezembro-de-2019-232670481"
        target="_blank"
        >Portaria GM/MS nº 3.222, de 10 de dezembro de 2019</a
      >, que dispõe sobre os indicadores do pagamento por desempenho, no âmbito
      do Programa Previne Brasil.
    </p>
    <br />
    <p><strong>Indicador 1 (I1) – Pré-Natal</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_13.pdf"
        target="_blank"
        >Nota Técnica 13/2022</a
      > - Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal
      realizadas, sendo a 1ª até a 12 ª semana de gestação.
    </p>
    <br />
    <p><strong>Indicador 2 (I2) – Sífilis e HIV</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_14.pdf"
        target="_blank"
        >Nota Técnica 14/2022</a
      > - Proporção de gestantes com realização de exames para sífilis e HIV.
    </p>
    <br />
    <p><strong>Indicador 3 (I3) – Pré-Natal Odontológico (PNO)</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_15.pdf"
        target="_blank"
        >Nota Técnica 15/2022</a
      > - Proporção de gestantes com atendimento odontológico realizado na
      Atenção Primária à Saúde.
    </p>
    <br />
    <p><strong>Indicador 4 (I4) – Citopatológico</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_16.pdf"
        target="_blank"
        >Nota Técnica 16/2022</a
      > - Proporção de mulheres com coleta de citopatológico na Atenção Primária
      à Saúde.
    </p>
    <br />
    <p><strong>Indicador 5 (I5) - Imunização</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_22.pdf"
        target="_blank"
        >Nota Técnica 22/2022</a
      > - Proporção de crianças de 1 (um) ano de idade vacinadas na APS contra
      Difteria, Tétano, Coqueluche, Hepatite B, infecções causadas
      por haemophilus influenzae tipo b e Poliomielite inativada.
    </p>
    <br />
    <p>
      <strong>Indicador 6 (I6) – Hipertensão Arterial Sistêmica (HAS)</strong>
    </p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_18.pdf"
        target="_blank"
        >Nota Técnica 18/2022</a
      > - Proporção de pessoas com hipertensão, com consulta e pressão arterial
      aferida no semestre.
    </p>
    <br />
    <p><strong>Indicador 7 (I7) – Diabetes (DM)</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_23.pdf"
        target="_blank"
        >Nota Técnica 23/2022</a
      > - Proporção de pessoas com diabetes, com consulta e hemoglobina glicada
      solicitada no semestre.
    </p>
    <br />
  </div>
</template>
<script>
export default {
  name: 'Geral',
}
</script>
<style scoped>
#modal-info {
  flex: 0 1 33%;
}

#modal-info button {
  width: 35px;
  height: 35px;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  float: right;
}

#modal-info-body h2 {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
#modal-info-body .notas-tecnicas {
  text-align: start;
  border-bottom: 1px solid #c1c1c1;
}
#modal-info-body h3 {
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0;
}

#modal-info-body p {
  font-size: 14px;
  text-align: justify;
  margin-bottom: 0;
}

#modal-info-body ul {
  margin: 10px 25px 10px 25px;
  list-style-type: disc;
}

#modal-info-body ul li {
  font-size: 14px;
}

.modal-info-accessibility ul {
  display: inline-flex;
  margin: 10px 0 !important;
  padding: 0;
  gap: 5px;
}

.modal-info-accessibility ul li {
  border: 1px solid;
  list-style-type: none;
  padding: 5px;
  width: 30px;
  text-align: center;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 3px;
}

.modal-info-accessibility ul li a {
  color: #fff;
  font-size: 14px;
}

.modal-info-accessibility ul li a:hover {
  color: #000;
}
</style>

